module.exports = __webpack_public_path__ + "static/desktop/img/material-6.4d91883f.jpg";